import GOOGLE_PLAY from '@/assets/images/app-qrcode/google-play.png';
import APPLE_STORE from '@/assets/images/app-qrcode/apple-store.png';
import { isAlipayBrowser } from '@/utils/common/device';
import useTranslation from 'next-translate/useTranslation';
import { buildUrlWithOrigin } from '@/utils/url';

const DownloadAppModule = () => {
  const { t, lang } = useTranslation('common');

  const downloadPlatform = [
    {
      icon: GOOGLE_PLAY,
      alt: 'google play'
    },
    {
      icon: APPLE_STORE,
      alt: 'apple store'
    }
  ];

  return (
    <div className="w-full h-full bg-primary-1">
      <div className="p-5">
        <div className="flex items-center">
          <img
            src="/favicons/apple-touch-icon.png"
            className="rounded-600 w-[82px] h-[82px] flex-none"
            alt="Apple touch icon"
          />
          <span className="enki-heading-xl text-primary-4 ml-[22px]">{t('fremont_intro_download_text')}</span>
        </div>
        {!isAlipayBrowser() && (
          <div className="flex items-center justify-between mt-5">
            {downloadPlatform.map(item => (
              <div
                onClick={() => {
                  location.href = 'https://www.sayweee.com/mgp/download-app';
                }}
                className="flex-1 box-border h-[47px] leading-[0] cursor-pointer rounded-200 bg-reserved-true-white border border-solid border-surface-100-hairline enki-elevation-4 flex items-center justify-center ml-[15px] text-center first:ml-0"
                key={item.alt}>
                <img src={item.icon} alt={item.alt} width={98} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DownloadAppModule;
